import type { FlightSuggestion } from "@b2bportal/core-flights";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";

import {
  fetchLocations,
  useFlightLocationAutocomplete,
  type FlightLocationAutocompleteProps,
} from "@tenant/flights";
import { Icon, LocationAutocomplete } from "@tenant/ui";

import defaultStyles from "./FlightLocationAutocomplete.module.scss";

const COMPONENT_KEY = CoreFlightsComponent.FlightsLocationAutocomplete;

export const FlightLocationAutocomplete = (
  props: FlightLocationAutocompleteProps
) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useFlightLocationAutocomplete(props);

  return (
    <div className={block}>
      <LocationAutocomplete<FlightSuggestion>
        id={context.id}
        defaultValue={context.defaultValue}
        value={context.value}
        label={context.label}
        onChange={handlers.onChange}
        fetch={fetchLocations}
        getOptionLabel={getOptionLabel}
        icon={<Icon iconName={IconNameEnum.mapPin} />}
        className={context.className}
        paperClassName={cn("location-paper")}
        popperClassName={cn("location-popper")}
        onOpen={handlers.onOpen}
        placeholder={context.placeholder}
        useDialogOnMobile={context.useDialogOnMobile ?? true}
        getOptionIcon={getOptionIcon}
        error={props.error}
        onFocus={props.onFocus}
      />
    </div>
  );
};

const getOptionLabel = (value?: FlightSuggestion) => {
  return value?.label ?? "";
};

const getOptionIcon = (value?: FlightSuggestion) => {
  return <Icon iconName={IconNameEnum.mapPin} />;
};
